import { Tabs } from 'antd';
import { Outlet, useMatch, useSearchParams } from 'react-router-dom';

import Page from '../components/Page';
import PageTitle from '../components/PageTitle';
import useTypedNavigate from '../hooks/useTypedNavigate';
import useTypedParams from '../hooks/useTypedParams';
import { JobPostingId } from '../types';

const EditOpportunityNavigator = () => {
  const { tenant, id } = useTypedParams({ tenant: String, id: JobPostingId });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/opportunities/:id/change/:activeTabKey/*');
  const [searchParams] = useSearchParams();

  return (
    <Page>
      <PageTitle
        title="Configuração da vaga"
        footer={
          <Tabs
            activeKey={match?.params?.activeTabKey || 'general'}
            onChange={(key) => {
              switch (key) {
                case 'general':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/general/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
                case 'profile':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/profile/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
                case 'description':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/description/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
                case 'stages':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/stages/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
                case 'allowedUsers':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/allowedUsers/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
                case 'publication':
                  navigate(
                    {
                      pathname: '/:tenant/opportunities/:id/change/publication/',
                      params: { tenant, id },
                      search: searchParams,
                    },
                    { replace: true }
                  );
                  break;
              }
            }}
            items={[
              { key: 'general', label: 'Geral' },
              { key: 'profile', label: 'Perfil' },
              {
                key: 'description',
                label: 'Descrição da vaga',
              },
              { key: 'stages', label: 'Fluxo de etapas' },
              { key: 'publication', label: 'Publicação' },
            ]}
          />
        }
      />
      <Outlet />
    </Page>
  );
};

export default EditOpportunityNavigator;
